import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { EventTrackingService } from '../../../services/event-tracking.service';
import { v4 } from 'uuid';
import { MarkPaperlessEnrollmentPageAsSeenReq } from '../models/paperless.model';

export const SIGNIN_SESSION_ID = 'signin-session-id';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  constructor(
    private readonly cookieService: CookieService,
    private readonly http: HttpClient,
    private readonly eventTrackingService: EventTrackingService
  ) {}

  dropIdTokenToCookie(idToken: string) {
    this.dropToCookie('X-Access-Token', `Bearer ${idToken}`, 60);
  }

  dropSignInSessionIdToCookie(signInCid: string, username?: string) {
    let signInSessionId = this.cookieService.get(SIGNIN_SESSION_ID);
    if (!signInSessionId) {
      signInSessionId = v4();
      this.dropToCookie(SIGNIN_SESSION_ID, signInSessionId, 60);
      this.eventTrackingService.initiateAuthSession({
        eventName: 'initiateSignInSession',
        cid: signInCid,
        signinsessionid: signInSessionId,
        customerUserName: username,
      });
    } else {
      this.dropToCookie(SIGNIN_SESSION_ID, signInSessionId, 60);
      this.eventTrackingService.trackEnterpriseEvent({
        eventName: 'renewSignInSession',
        cid: signInCid,
        signinsessionid: signInSessionId,
      });
    }
  }

  dropAuthSessionIdToCookie() {
    this.dropToCookie('auth-session-id', sessionStorage.getItem('auth-session-id'), 60);
    this.dropToCookie('be-auth', 'Y', 60 * 24 * 365);
  }

  dropCidToCookie(cid: string) {
    this.dropToCookie('cid', cid, 60 * 24 * 365);
  }

  dropIsBEFHOnlyCustomerToCookie(befhOnlyFlag: boolean) {
    this.dropToCookie('befh-only', befhOnlyFlag.toString(), 60 * 24 * 365);
  }

  dropToCookie(header: string, value: string, minutes: number) {
    const currentDate = new Date();
    currentDate.setTime(currentDate.getTime() + 60 * 1000 * minutes);
    this.cookieService.delete(header);
    this.cookieService.set(header, value, currentDate, '/', environment.domainUrl, !environment.local, 'Strict');
  }

  getSelfServiceableAccounts(idToken: string) {
    return this.http.get(`${environment.customerGateway}/accounts`, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  }

  markPaperlessEnrollmentPageAsSeen(req: MarkPaperlessEnrollmentPageAsSeenReq) {
    return this.http.post(`${environment.paperlessStatusUpdateEndpoint}/seen`, req, {});
  }

  logCardSso(saml: string) {
    return this.http.post(
      `${environment.cardSsoLogUrl}`,
      { request: saml },
      {
        headers: { Authorization: this.cookieService.get('X-Access-Token') },
      }
    );
  }
}
